<template>
  <div class="c-modal-wrapper">
    <transition name="modal">
      <div class="c-modal-wrapper_mask">
        <div class="c-modal-wrapper_holder">
          <div class="c-modal-wrapper-container">
            <div class="m-verification-age">
              <div class="add-cash-modal-head">
                <p class="add-cash-modal-head_title">
                  {{ $t('modals.verification') }}
                </p>
                <div @click="onClose" class="add-cash-modal-head_close">
                  <img src="@/assets/icons/close.svg" alt="close remove">
                </div>
              </div>
              <div class="m-verification-age-body">
                <p class="m-verification-age-body_text">
                  {{ $t('modals.verificationText') }}
                </p>
              </div>
              <div v-if="percentage < 100" class="m-verification-age-progress">
                <ProgressBarPercentage
                  :percentage="percentage"
                />
              </div>
              <div v-if="percentage >= 100" class="m-verification-age-progress">
                <LoadAnimation
                  class="m-verification-age-progress--loader"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed, onUnmounted, ref } from "vue";
import ModalWrapper from "@/components/modals/ModalWrapper.vue";
import ProgressBarPercentage from "@/components/animations/ProgressBarPercentage.vue";
import LoadAnimation from "@/components/animations/LoadAnimation.vue";

export default {
  name: "CheckAgeTextModal",
  components: {
    LoadAnimation,
    ProgressBarPercentage,
    ModalWrapper
  },
  props: {
    modelName: {
      type: String
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const percentage = ref(0);
    const intervalLoad = ref(null);
    const createLoadWatcher = () => {
      if (percentage.value >= 100) {
        clearInterval(intervalLoad.value);
        percentage.value = 0;
      }

      intervalLoad.value = setInterval(async () => {
        percentage.value = percentage.value + 1;
        if (percentage.value >= 100) {
          clearInterval(intervalLoad.value);
          intervalLoad.value = null;
        }
      }, 65);
    };
    createLoadWatcher();
    const onClose = () => {
      store.commit('removeAllModal');
      emit('closeModal');
      store.dispatch('getUserProfile');
      clearInterval(intervalLoad.value);
    }
    onUnmounted(() => {
      clearInterval(intervalLoad.value);
      percentage.value = 0
    })
    return {
      onClose,
      percentage
    }
  }
}
</script>
<style lang="scss">
.m-verification-age {
  background-color: rgb(22, 22, 22);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  margin: 0 auto;
  padding: 20px 30px;
  border-radius: 15px;
  width: 500px;
  min-height: 270px;
  @media screen and (max-width: 900px) {
    width: 95%;
  }
  @media screen and (max-width: 500px) {
    min-height: 290px;
  }
  @media screen and (max-width: 375px) {
    min-height: 250px;
  }
  @media screen and (max-height: 330px) {
    overflow: auto;
    height: 270px;
  }
  .add-cash-modal-head_title {
    @media screen and (max-width: 375px) {
      font-size: 14px;
    }
  }
  .add-cash-modal-head {
    @media screen and (max-width: 375px) {
      margin-bottom: 10px;
    }
  }
  &-body  {
    border-top: 2px solid rgba(255, 255, 255, 0.2);
    padding-top: 20px;
    opacity: 0.75;
    @media screen and (max-width: 375px) {
      padding-top: 10px;
    }
    &_image {
      border-radius: 14px;
      width: 100%;
      object-fit: contain;
      height: auto;
      display: block;
      margin: 20px auto 0 auto;
    }
    &_text {
      font-size: 22px;
      line-height: 27px;
      @media screen and (max-width: 550px) {
        font-size: 18px;
      }
      @media screen and (max-width: 375px) {
        font-size: 14px;
        line-height: 18px;
      }
    }
  }
  &-progress {
    display: block;
    width: 100%;
    height: 30px;
    position: relative;
    margin-top: 20px;
    .c-progress-bar {
      margin-top: 0;
    }
    &--loader {
      position: absolute !important;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin-top: 10px;
    }
    .lds-spinner div:after {
      display: block;
      position: absolute;
      top: 18.2px;
      left: 36.8px;
      width: 3.4px;
      height: 7.6px;
    }
  }
}
</style>
